import { useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import { useLanguage } from '../../context/LanguageContext';

export default function TermsOfService() {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-8">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A2B4A] mb-6">
            {t('termsOfService.title')}
          </h1>
          <p className="text-gray-600 mb-12">
            {t('termsOfService.lastUpdated')}
          </p>

          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.introTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.introText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.purposeTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.purposeText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.intellectualTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.intellectualText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.limitationTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.limitationText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.externalTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.externalText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.changesTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.changesText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.governingTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.governingText')}
              </p>
            </section>

            <section className="bg-gray-50 p-8 rounded-lg border border-gray-200">
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('termsOfService.contactTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.contactText')}
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}